import { TrackerEvent } from '../../../tracker-event';
import {
  getPayloadForCategoryView,
  getPayloadForCourseView,
  getPayloadForSPA,
  getPayloadForTransactionPayment,
} from '../../support';

export const events = ({ tracker, condition }) => {
  const gAdsDynamic = tracker;
  const userId = condition.userId;

  return {
    [TrackerEvent.PAGE_VIEW]() {
      const adsData = { user_id: userId };
      gAdsDynamic({ event: 'page_view', data: adsData });
    },
    [TrackerEvent.USER_SIGNUP]() {
      const adsData = { user_id: userId };
      gAdsDynamic({ event: 'sign_up', data: adsData });
    },
    [TrackerEvent.USER_LOGIN]() {
      const adsData = { user_id: userId };
      gAdsDynamic({ event: 'login', data: adsData });
    },
    [TrackerEvent.FORMAT_VIEW]() {},
    [TrackerEvent.CATEGORY_VIEW](category) {
      const adsData = { user_id: userId };
      if (category) {
        const payload = getPayloadForCategoryView({ category, userId: userId });
        adsData.items = payload.items;
      }
      gAdsDynamic({ event: 'view_item_list', data: adsData });
    },
    [TrackerEvent.COURSE_VIEW](course) {
      const adsData = {
        user_id: userId,
        edu_pagetype: 'program',
      };
      if (course) {
        const payload = getPayloadForCourseView({ course, userId: userId });
        adsData.items = payload.items;
        adsData['edu_pid'] = payload.edu_pid;
      }
      gAdsDynamic({ event: 'view_item', data: adsData });
    },
    [TrackerEvent.ENROLLMENT_VIEW](data) {
      const adsData = { user_id: userId };
      if (data) {
        const payload = getPayloadForSPA({ data });
        adsData.items = payload.items;
        adsData['edu_pid'] = payload.edu_pid;
      }
      gAdsDynamic({ event: 'initiate_enrollment', data: adsData });
    },
    [TrackerEvent.ENROLLMENT_PENDING](data) {
      const adsData = { user_id: userId };
      if (data) {
        const payload = getPayloadForSPA({ data });
        adsData.items = payload.items;
        adsData['edu_pid'] = payload.edu_pid;
      }
      gAdsDynamic({ event: 'begin_checkout', data: adsData });
    },
    [TrackerEvent.TRANSACTION_ORDER](data) {
      const adsData = { user_id: userId };
      if (data) {
        const payload = getPayloadForSPA({ data, userId: userId });
        adsData.items = payload.items;
        adsData['edu_pid'] = payload.edu_pid;
      }
      gAdsDynamic({ event: 'begin_checkout', data: adsData });
    },
    [TrackerEvent.TRANSACTION_PAYMENT](data) {
      const adsData = { user_id: userId, edu_pagetype: 'complete' };
      if (data) {
        const payload = getPayloadForTransactionPayment({ data, userId: userId });
        adsData.items = payload.items;
        adsData['edu_pid'] = payload.edu_pid;
      }
      gAdsDynamic({ event: 'purchase', data: adsData });
    },
  };
};
